// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overall page layout */
.workflow-details-page {
    max-width: 95%;
    margin: 0 auto;
    padding: 32px 24px 48px;
    background-color: #f7f9fc;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", sans-serif;
    color: #1f2933;
}

/* Header */
.workflow-header {
    margin-bottom: 24px;
}

.workflow-title {
    font-size: 1.6rem;
    font-weight: 600;
    color: #111827;
    margin: 0;
}

/* Sections */
.workflow-section {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 20px 24px;
    margin-bottom: 20px;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);
    border: 1px solid #e5e7eb;
}

.workflow-section-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 12px;
}

/* Summary */
.workflow-summary {
    line-height: 1.6;
    font-size: 0.95rem;
    color: #374151;
}

.workflow-muted-text {
    font-size: 0.9rem;
    color: #9ca3af;
}

/* Diagram */
.workflow-diagram-container {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    flex-wrap: wrap;
}

.workflow-diagram-raw {
    background-color: #f9fafb;
    padding: 12px;
    border-radius: 8px;
    overflow-x: auto;
    white-space: pre-wrap;
    max-width: 600px;
    font-size: 0.85rem;
    border: 1px solid #e5e7eb;
    color: #4b5563;
}

.workflow-diagram-image-wrapper {
    max-width: 600px;
}

.workflow-diagram-image {
    width: 100%;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    background-color: #ffffff;
}

/* Programs table */
.workflow-programs-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
}

.workflow-programs-header-step,
.workflow-programs-header-programs {
    border: 1px solid #e5e7eb;
    padding: 8px 10px;
    background-color: #f3f4f6;
    font-weight: 600;
    text-align: left;
}

.workflow-programs-header-step {
    width: 20%;
}

.workflow-programs-step-cell {
    border: 1px solid #e5e7eb;
    padding: 8px 10px;
    font-weight: 600;
    color: #111827;
    background-color: #ffffff;
}

.workflow-programs-programs-cell {
    border: 1px solid #e5e7eb;
    padding: 8px 10px;
    background-color: #ffffff;
}

.workflow-program-entry {
    margin-bottom: 6px;
    color: #374151;
}

.workflow-program-default-params {
    margin-left: 10px;
    color: #6b7280;
    font-size: 0.85rem;
}

/* Loading / error */
.workflow-loading-text,
.workflow-error-text {
    padding: 24px;
    text-align: center;
    font-size: 0.95rem;
}

.workflow-error-text {
    color: #b91c1c;
}

.workflow-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.workflow-modal {
    background: #ffffff;
    width: 420px;
    max-width: 90%;
    border-radius: 12px;
    padding: 24px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 12px 32px rgba(0,0,0,0.15);
    outline: none;
}

.upload-dropzone-disabled {
    opacity: 0.5;
    pointer-events: none;
}

.upload-primary-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.workflow-insufficient-credits-alert {
    margin-top: 20px;
    color: #b30000;
    font-weight: bold;
    font-size: 14px;
}

/* OTS launch-page "How to run" instructions (admin-authored markdown). */
.ots-instructions h1,
.ots-instructions h2,
.ots-instructions h3 {
  color: #111827;
  margin: 18px 0 8px;
  line-height: 1.3;
}
.ots-instructions h1 { font-size: 1.15rem; }
.ots-instructions h2 { font-size: 1.05rem; }
.ots-instructions h3 { font-size: 0.98rem; }
.ots-instructions p { margin: 8px 0; }
.ots-instructions ul,
.ots-instructions ol { margin: 8px 0; padding-left: 22px; }
.ots-instructions li { margin: 4px 0; }
.ots-instructions a { color: #2563eb; text-decoration: none; }
.ots-instructions a:hover { text-decoration: underline; }
.ots-instructions code {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 1px 5px;
  font-size: 0.86em;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
.ots-instructions pre {
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 8px;
  padding: 12px 14px;
  overflow-x: auto;
}
.ots-instructions pre code { background: none; border: none; color: inherit; padding: 0; }
.ots-instructions table {
  border-collapse: collapse;
  width: 100%;
  margin: 12px 0;
  font-size: 0.88rem;
}
.ots-instructions th,
.ots-instructions td {
  border: 1px solid #e5e7eb;
  padding: 7px 10px;
  text-align: left;
  vertical-align: top;
}
.ots-instructions thead th {
  background: #f8fafc;
  font-weight: 600;
  color: #111827;
}
.ots-instructions tbody tr:nth-child(even) { background: #fafafa; }
.ots-instructions blockquote {
  margin: 10px 0;
  padding: 6px 14px;
  border-left: 3px solid #93c5fd;
  background: #eff6ff;
  color: #1e3a5f;
  border-radius: 0 6px 6px 0;
}

/* OTS pipeline documentation — inline diagrams (nf-core-style flow images) */
.ots-instructions img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 14px 0;
  border: 1px solid #e6eaef;
  border-radius: 12px;
  background: #fff;
}
.ots-instructions h1:first-child,
.ots-instructions h2:first-child { margin-top: 0; }
.ots-instructions hr { border: none; border-top: 1px solid #e6eaef; margin: 18px 0; }
`, "",{"version":3,"sources":["webpack://./src/css/WorkflowDetails.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,cAAc;IACd,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,gGAAgG;IAChG,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA,aAAa;AACb;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;;IAEI,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;;IAEI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA,yEAAyE;AACzE;;;EAGE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA,uBAAuB,kBAAkB,EAAE;AAC3C,uBAAuB,kBAAkB,EAAE;AAC3C,uBAAuB,kBAAkB,EAAE;AAC3C,sBAAsB,aAAa,EAAE;AACrC;uBACuB,aAAa,EAAE,kBAAkB,EAAE;AAC1D,uBAAuB,aAAa,EAAE;AACtC,sBAAsB,cAAc,EAAE,qBAAqB,EAAE;AAC7D,4BAA4B,0BAA0B,EAAE;AACxD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,2DAA2D;AAC7D;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,6BAA6B,gBAAgB,EAAE,YAAY,EAAE,cAAc,EAAE,UAAU,EAAE;AACzF;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA,6CAA6C,mBAAmB,EAAE;AAClE;EACE,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,6EAA6E;AAC7E;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;mCACmC,aAAa,EAAE;AAClD,uBAAuB,YAAY,EAAE,6BAA6B,EAAE,cAAc,EAAE","sourcesContent":["/* Overall page layout */\n.workflow-details-page {\n    max-width: 95%;\n    margin: 0 auto;\n    padding: 32px 24px 48px;\n    background-color: #f7f9fc;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"SF Pro Text\", \"Segoe UI\", sans-serif;\n    color: #1f2933;\n}\n\n/* Header */\n.workflow-header {\n    margin-bottom: 24px;\n}\n\n.workflow-title {\n    font-size: 1.6rem;\n    font-weight: 600;\n    color: #111827;\n    margin: 0;\n}\n\n/* Sections */\n.workflow-section {\n    background-color: #ffffff;\n    border-radius: 12px;\n    padding: 20px 24px;\n    margin-bottom: 20px;\n    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.04);\n    border: 1px solid #e5e7eb;\n}\n\n.workflow-section-title {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #111827;\n    margin: 0 0 12px;\n}\n\n/* Summary */\n.workflow-summary {\n    line-height: 1.6;\n    font-size: 0.95rem;\n    color: #374151;\n}\n\n.workflow-muted-text {\n    font-size: 0.9rem;\n    color: #9ca3af;\n}\n\n/* Diagram */\n.workflow-diagram-container {\n    display: flex;\n    gap: 20px;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.workflow-diagram-raw {\n    background-color: #f9fafb;\n    padding: 12px;\n    border-radius: 8px;\n    overflow-x: auto;\n    white-space: pre-wrap;\n    max-width: 600px;\n    font-size: 0.85rem;\n    border: 1px solid #e5e7eb;\n    color: #4b5563;\n}\n\n.workflow-diagram-image-wrapper {\n    max-width: 600px;\n}\n\n.workflow-diagram-image {\n    width: 100%;\n    border-radius: 8px;\n    border: 1px solid #e5e7eb;\n    background-color: #ffffff;\n}\n\n/* Programs table */\n.workflow-programs-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.9rem;\n}\n\n.workflow-programs-header-step,\n.workflow-programs-header-programs {\n    border: 1px solid #e5e7eb;\n    padding: 8px 10px;\n    background-color: #f3f4f6;\n    font-weight: 600;\n    text-align: left;\n}\n\n.workflow-programs-header-step {\n    width: 20%;\n}\n\n.workflow-programs-step-cell {\n    border: 1px solid #e5e7eb;\n    padding: 8px 10px;\n    font-weight: 600;\n    color: #111827;\n    background-color: #ffffff;\n}\n\n.workflow-programs-programs-cell {\n    border: 1px solid #e5e7eb;\n    padding: 8px 10px;\n    background-color: #ffffff;\n}\n\n.workflow-program-entry {\n    margin-bottom: 6px;\n    color: #374151;\n}\n\n.workflow-program-default-params {\n    margin-left: 10px;\n    color: #6b7280;\n    font-size: 0.85rem;\n}\n\n/* Loading / error */\n.workflow-loading-text,\n.workflow-error-text {\n    padding: 24px;\n    text-align: center;\n    font-size: 0.95rem;\n}\n\n.workflow-error-text {\n    color: #b91c1c;\n}\n\n.workflow-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0,0,0,0.45);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n}\n\n.workflow-modal {\n    background: #ffffff;\n    width: 420px;\n    max-width: 90%;\n    border-radius: 12px;\n    padding: 24px;\n    border: 1px solid #e5e7eb;\n    box-shadow: 0 12px 32px rgba(0,0,0,0.15);\n    outline: none;\n}\n\n.upload-dropzone-disabled {\n    opacity: 0.5;\n    pointer-events: none;\n}\n\n.upload-primary-button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.workflow-insufficient-credits-alert {\n    margin-top: 20px;\n    color: #b30000;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n/* OTS launch-page \"How to run\" instructions (admin-authored markdown). */\n.ots-instructions h1,\n.ots-instructions h2,\n.ots-instructions h3 {\n  color: #111827;\n  margin: 18px 0 8px;\n  line-height: 1.3;\n}\n.ots-instructions h1 { font-size: 1.15rem; }\n.ots-instructions h2 { font-size: 1.05rem; }\n.ots-instructions h3 { font-size: 0.98rem; }\n.ots-instructions p { margin: 8px 0; }\n.ots-instructions ul,\n.ots-instructions ol { margin: 8px 0; padding-left: 22px; }\n.ots-instructions li { margin: 4px 0; }\n.ots-instructions a { color: #2563eb; text-decoration: none; }\n.ots-instructions a:hover { text-decoration: underline; }\n.ots-instructions code {\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  padding: 1px 5px;\n  font-size: 0.86em;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n.ots-instructions pre {\n  background: #0f172a;\n  color: #e2e8f0;\n  border-radius: 8px;\n  padding: 12px 14px;\n  overflow-x: auto;\n}\n.ots-instructions pre code { background: none; border: none; color: inherit; padding: 0; }\n.ots-instructions table {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 12px 0;\n  font-size: 0.88rem;\n}\n.ots-instructions th,\n.ots-instructions td {\n  border: 1px solid #e5e7eb;\n  padding: 7px 10px;\n  text-align: left;\n  vertical-align: top;\n}\n.ots-instructions thead th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #111827;\n}\n.ots-instructions tbody tr:nth-child(even) { background: #fafafa; }\n.ots-instructions blockquote {\n  margin: 10px 0;\n  padding: 6px 14px;\n  border-left: 3px solid #93c5fd;\n  background: #eff6ff;\n  color: #1e3a5f;\n  border-radius: 0 6px 6px 0;\n}\n\n/* OTS pipeline documentation — inline diagrams (nf-core-style flow images) */\n.ots-instructions img {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 14px 0;\n  border: 1px solid #e6eaef;\n  border-radius: 12px;\n  background: #fff;\n}\n.ots-instructions h1:first-child,\n.ots-instructions h2:first-child { margin-top: 0; }\n.ots-instructions hr { border: none; border-top: 1px solid #e6eaef; margin: 18px 0; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
